
import { Component, Input, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { SLEntity } from '../entity';
import { TOption } from '../../../ui';
import { SLEntityTypePipe } from '../entity-type.pipe';
import { COUNTRIES } from '../countries';


@Component({
  selector: 'sl-entity-form',
  templateUrl: './entity-form.component.html',
})
export class SLEntityFormComponent implements OnChanges {

  @Input()
  entity: SLEntity

  @ViewChild('nameInput')
  nameInput: ElementRef

  entityTypeOptions: TOption[] = [
    {
      value: 'COMPANY',
      text: new SLEntityTypePipe().transform('COMPANY'),
    },
    {
      value: 'PERSON',
      text: new SLEntityTypePipe().transform('PERSON'),
    },
  ];

  countries = COUNTRIES;

  name: FormControl
  line1: FormControl
  country: FormControl

  constructor() { }

  initForm() {
    // name
    this.name = new FormControl(this.entity.name, [
      Validators.required
    ]);

    this.name.valueChanges.subscribe((value) => {
      this.entity.name = value;
    });

    // line1
    this.line1 = new FormControl(this.entity.address.line1, [
      Validators.required
    ]);

    this.line1.valueChanges.subscribe((value) => {
      this.entity.address.line1 = value;
    });

    // country
    this.country = new FormControl(this.entity.address.country, [
      Validators.required
    ]);

    this.country.valueChanges.subscribe((value) => {
      this.entity.address.country = value;
    });

    // Focus name input
    this.nameInput.nativeElement.focus();
  }

  ngOnChanges() {
    this.initForm();
  }
}
